import {
  Component,
  OnInit,
  ViewChild,
  ViewEncapsulation,
  Input,
  EventEmitter,
  Output,
} from '@angular/core';
import { AgGridAngular } from '@ag-grid-community/angular';
import { AllModules } from '@ag-grid-enterprise/all-modules';

import { PayrollEntry } from 'app/api/payroll.api.service';

import { agGridLocale, DecimalCellRenderer } from 'app/utils/ag-grid.locale';
import * as moment from 'moment';

@Component({
  selector: 'app-ecran-v1',
  templateUrl: './ecran-v1.component.html',
  styleUrls: ['./ecran-v1.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class EcranV1Component implements OnInit {
  public gridApi;
  public gridColumnApi;

  public columnDefs;
  public defaultColDef;
  public sideBar;
  public statusBar;
  public rowBuffer;
  public localeText;
  public modules;

  // tslint:disable-next-line: no-input-rename
  @Input('data') rows: PayrollEntry[] = [];
  @Input() excelStyles;
  // tslint:disable-next-line: no-output-on-prefix
  @Output() onGridReadyEvent = new EventEmitter();

  private _search = '';
  @Input()
  set search(value: string) {
    this._search = value;
    if (this.gridApi) {
      this.gridApi.setQuickFilter(value);
    }
  }

  @ViewChild('agGrid', { static: false }) agGrid: AgGridAngular;

  constructor() {
    this.modules = AllModules;
    this.localeText = agGridLocale.fr;
    this.columnDefs = this.getColumnDefs();
    this.defaultColDef = {
      enableValue: true,
      enableRowGroup: true,
      enablePivot: true,
      sortable: true,
      filter: true,
      resizable: true,
    };
    // this.sideBar = {
    //     toolPanels: [
    //         {
    //             id: 'columns',
    //             labelDefault: 'Colonnes',
    //             labelKey: 'columns',
    //             iconKey: 'columns',
    //             toolPanel: 'agColumnsToolPanel',
    //         },
    //         {
    //             id: 'filters',
    //             labelDefault: 'Filtres',
    //             labelKey: 'filters',
    //             iconKey: 'filter',
    //             toolPanel: 'agFiltersToolPanel',
    //         },
    //     ],
    // };
    this.statusBar = {
      statusPanels: [
        {
          statusPanel: 'agTotalRowCountComponent',
          align: 'left',
        },
        {
          statusPanel: 'agAggregationComponent',
        },
        { statusPanel: 'agSelectedRowCountComponent' },
        { statusPanel: 'agFilteredRowCountComponent' },
      ],
    };
  }

  ngOnInit(): void {}

  getColumnDefs(): any[] {
    return [
    //   {
    //     headerName: 'Date',
    //     field: 'month',
    //     valueGetter: (params) =>
    //       params.data ? moment(params.data.entryDate).format('YYYY-MM') : '',
    //   },
      {
        headerName: 'Mois',
        field: 'month',
        valueGetter: (params) =>
          params.data ? moment(params.data.month).format('MMM YY') : '',
      },
      { headerName: 'Matricule', field: 'matricule', cellClass: 'excelString' },
      { headerName: 'Nom Prénom', field: 'name', cellClass: 'excelString' },
      {
        headerName: 'Brut complet',
        children: [
          // tslint:disable-next-line:max-line-length
          {
            headerName: 'Brut',
            field: 'raw',
            columnGroupShow: 'closed',
            cellClass: ['ag-numeric-cell', 'excelString'],
            cellRenderer: DecimalCellRenderer,
          },
          // tslint:disable-next-line:max-line-length
          {
            headerName: 'Primes',
            field: 'primes',
            columnGroupShow: 'closed',
            cellClass: ['ag-numeric-cell', 'excelString'],
            cellRenderer: DecimalCellRenderer,
          },
          {
            headerName: 'Heures supp',
            field: 'extra',
            columnGroupShow: 'closed',
            cellClass: ['ag-numeric-cell', 'excelString'],
            cellRenderer: DecimalCellRenderer,
          },
          {
            headerName: 'Autre brut',
            field: 'others',
            columnGroupShow: 'closed',
            cellClass: ['ag-numeric-cell', 'excelString'],
            cellRenderer: DecimalCellRenderer,
          },
          {
            headerName: 'Total',
            columnGroupShow: 'open',
            field: 'fullRaw',
            cellClass: ['ag-numeric-cell', 'excelString'],
            cellRenderer: DecimalCellRenderer,
          },
        ],
      },
      {
        headerName: 'Charges patronales',
        field: 'charges',
        cellClass: ['ag-numeric-cell', 'excelString'],
        cellRenderer: DecimalCellRenderer,
      },
      {
        headerName: 'BRUT CHARGÉ',
        field: 'fullRawCharges',
        headerClass: ['fw-bolder'],
        cellClass: ['ag-numeric-cell', 'brut-charge', 'excelString'],
        cellRenderer: DecimalCellRenderer,
      },
    ];
  }

  onGridReady(params): void {
    this.onGridReadyEvent.emit(params);
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    this.gridApi.setQuickFilter(this._search);
  }

  public clearSearch(): void {
    this.gridApi.setQuickFilter('');
  }

  onFirstDataRendered(params): void {
    this.autoSizeAll(params);
  }

  private autoSizeAll(params): void {
    const allColumnIds = params.columnApi
      .getAllColumns()
      .map((column) => column.colId);
    setTimeout(() => params.columnApi.autoSizeColumns(allColumnIds), 0);
  }
}
